/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetApMismatchAlertSettingsResponse } from '../model/getApMismatchAlertSettingsResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * Get the mismatch alert settings configured for the current office.
 * @summary Get a list of mismatch alert settings
 */
export const useGetApMismatchAlertSettingsHook = () => {
  const getApMismatchAlertSettings =
    useCustomClient<GetApMismatchAlertSettingsResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApMismatchAlertSettings(
      { url: `/api/js/ap_mismatch_alert_settings`, method: 'GET', signal },
      options
    );
  };
};

export const getGetApMismatchAlertSettingsQueryKey = () => {
  return [`/api/js/ap_mismatch_alert_settings`] as const;
};

export const useGetApMismatchAlertSettingsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApMismatchAlertSettingsQueryKey();

  const getApMismatchAlertSettings = useGetApMismatchAlertSettingsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>
  > = ({ signal }) => getApMismatchAlertSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApMismatchAlertSettingsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>
>;
export type GetApMismatchAlertSettingsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get a list of mismatch alert settings
 */
export const useGetApMismatchAlertSettings = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApMismatchAlertSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApMismatchAlertSettingsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApMismatchAlertSettingsQueryKey();

  const getApMismatchAlertSettings = useGetApMismatchAlertSettingsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>
  > = ({ signal }) => getApMismatchAlertSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApMismatchAlertSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>
>;
export type GetApMismatchAlertSettingsSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get a list of mismatch alert settings
 */
export const useGetApMismatchAlertSettingsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApMismatchAlertSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApMismatchAlertSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
